/** Trimmed RS Works brand PNGs — served from /brand (apps/web/public/brand). */
export const BRAND_ASSETS = {
  horizontalLight: '/brand/rsworks-horizontal-light.png',
  horizontalDark: '/brand/rsworks-horizontal-dark.png',
  markLight: '/brand/rsworks-mark-light.png',
  markDark: '/brand/rsworks-mark-dark.png',
  favicon: '/brand/favicon.png',
  pwaIcon192: '/brand/pwa-icon-192.png',
  pwaIcon512: '/brand/pwa-icon-512.png',
};
